import axios, { AxiosInstance } from "axios";
import { RootState } from "./store";
// import { logout, updateToken } from "../slices/authSlice";
import store from "./store";
import { logout } from "./slices/auth";

const axiosInstance = axios.create({
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

// Interceptor untuk menyisipkan token di header request
axiosInstance.interceptors.request.use(
  (config) => {
    const state: RootState = store.getState();
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor untuk menangani Refresh Token saat token kadaluarsa
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const state: RootState = store.getState();
        const refreshToken = localStorage.getItem("tokenRefresh")
        const employeeId = state.Auth.loginData.employeeId

        // Panggil endpoint refresh token
        const response = await axios.post("https://api.v2.attendance.dailyapp.id/v1/prod/user/refresh-token",
              { employeeId: employeeId },
              {headers: {
                Authorization: `Bearer ${refreshToken}`
              }}
            );

        const newToken = response.data.data.token;
       
        localStorage.setItem("token", newToken)
        // Perbarui header Authorization dan ulangi permintaan
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        // Jika refresh token gagal, logout user
        store.dispatch(logout());
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
